import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Wraps a route that requires authentication AND the site_admin role.
 *
 * - While the startup token check is still in-flight (authLoading), renders
 *   nothing so the user never sees a flash-redirect.
 * - Redirects to /login if not authenticated.
 * - Redirects to /dashboard if authenticated but not a site admin.
 */
export default function AdminRoute({ children }) {
  const { isLoggedIn, isAdmin, authLoading } = useAuth();

  if (authLoading) return null;

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
